
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M746.7 740.854c-44.857 16.954-96.618-14.613-136.662-63.48a415.376 415.376 0 01-220.076 0c-40.044 48.867-91.805 80.434-136.662 63.48C124.91 692.3 127.38 597.33 162.427 465.22 211.447 280.43 285.354 239.205 366.7 259.053c28.51 6.96 40.52 20.499 40.52 20.499a417.536 417.536 0 01185.562 0s12.01-13.54 40.52-20.5c81.345-19.847 155.253 21.378 204.272 206.17C872.619 597.33 875.09 692.3 746.7 740.853z","fill":"#4d3d36"}}),_c('ellipse',{attrs:{"cx":"390.418","cy":"531.766","rx":"59.248","ry":"63.757","fill":"#f7f4e5"}}),_c('ellipse',{attrs:{"cx":"609.579","cy":"531.766","rx":"59.248","ry":"63.757","fill":"#f7f4e5"}}),_c('path',{attrs:{"d":"M319.459 648.548C369.865 675.14 432.337 690.88 500 690.88s130.136-15.729 180.532-42.33","fill":"none","stroke":"#8a9cf2","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"41"}})])
          )
        }
      }
    